<template>
  <div class="tableMarkerBind" :style="{height:isLarge?'calc(100% - 50px)':''}" v-show="isShow" ref="main">
    <div class="header">
      <div class="left">
        <span class="name">数据绑定</span>
        <!-- <span class="text">（已选择 <span style="color: white">{{selectedData.length}}</span> 条，共 <span style="color: white">400</span> 条记录）</span> -->
      </div>
      <div class="right">
        <el-tooltip content="关闭" placement="top" effect="light" @click.native="onClose">
          <Icon name="icon-close-bold"></Icon>
        </el-tooltip>
      </div>
    </div>
    <div class="tableBox">
      <el-table
        ref="multipleTable"
        stripe
        :data="loadedData"
        height="100%"
        style="width: 100%"
        @current-change="clickChange"
        v-loading.fullscreen.lock="tableLoading"
        element-loading-background="rgba(0, 0, 0, 0.5)"
        v-el-table-infinite-scroll="loadMore"
      >
        <!-- <el-table-column type="selection" width="50" :selectable="canSelect">
        </el-table-column> -->
        <el-table-column label="选择" :width="55*zoomFactor">
          <template slot-scope="scope">
            <el-radio v-model="selectedData" :label="scope.row" :disabled="isDisabled(scope.row)"><i></i></el-radio>
          </template>
        </el-table-column>
        <el-table-column label="序号" :width="50*zoomFactor">
          <template slot-scope="scope">
            <span class="num">{{scope.$index+1}}</span>
          </template>
        </el-table-column>
        <el-table-column  v-for="(item,index) in tableHeader" :key="index" :label="item.name" show-overflow-tooltip :prop="item.id.toString()" :width="tableHeader.length>9?203*zoomFactor:'auto'">
        </el-table-column>
        <template slot="empty">
         <Empty></Empty>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import page from '@/mixins/page'
import { getBindTable } from '@/api/dataManagement'
import { getLayer, getMarkerList, getEnablTableData } from '@/api/marker'
export default {
  name: 'TableMarkerBind',
  props: {
    layerData: {
      type: Object,
      default: null
    }
  },
  mixins: [page],
  components: {},
  data () {
    return {
      isLarge: false,
      tableHeader: [],
      tablesData: [],
      isShow: false,
      selectedData: undefined,
      gisHeader: {
        lonHeader: undefined,
        latHeader: undefined,
        nameHeader: undefined
      },
      layerType: undefined,
      pageNumber: 1,
      coordinatesType: '',
      tableLoading: false
    }
  },
  computed: {
    // _layerData () {
    //   return this.layerData
    // },
    ...mapGetters(['isLeftDrawVisible', 'isRightDrawVisible']),
    filterData () {
      const data = []
      for (let i = 0; i < this.tablesData.length; i++) {
        const item = this.tablesData[i]
        if (!this.isDisabled(item)) {
          data.push(item)
        }
      }
      return data
    },
    loadedData () {
      const count = Math.min(this.pageNumber * 20, this.filterData.length)
      return this.filterData.slice(0, count)
    }
  },
  mounted () {
    // this.getMarkerList()
  },
  watch: {
    // _layerData (newValue, oldValue) {
    //   this.getMarkerList()
    // }
    isRightDrawVisible (v) {
      this.resize()
    },
    isLeftDrawVisible (v) {
      this.resize()
    }
    // filterData (v) {
    //   if (this.filterData.length <= 0 && this.next) {
    //     this.loadMore()
    //   }
    // }
  },
  methods: {
    // 获取图层属性
    async getLayerData (layerId) {
      const res = await getLayer({
        id: layerId
      })
      if (res.code === 200) {
        this.tableId = res.data.tableId
        this.layerType = res.data.type
        this.getEnableTable()
      }
    },
    // 获取图层标注
    getLayerMarker (layerId) {
      getMarkerList({
        layerId: layerId,
        pageNumber: 1,
        pageSize: 10000
      }).then(res => {
        if (res.code === 200) {
          this.markerList = res.data.records
          this.getTablesData(this.tableId)
        }
      })
    },
    // 获取表格数据
    getTablesData (id) {
      getBindTable({
        pageNumber: this.pageNumber,
        pageSize: 20,
        id: id
      }).then(res => {
        if (res.code === 200) {
          if (res.data.id !== id) {
            return
          }
          this.tablesData = this.tablesData.concat(res.data.data.records)
          this.coordinatesType = res.data.coordinatesType
          this.tableHeader = res.data.properties
          this.gisHeader = this.getGisHeader(this.tableHeader)
          this.next = res.data.data.next
        }
      })
    },
    async getEnableTable () {
      try {
        this.tableLoading = true
        const res = await getEnablTableData({
          layerId: this.layerId,
          pageNumber: this.pageNumber,
          pageSize: 9999999
        })
        this.tablesData = this.tablesData.concat(res.data.data.records)
        this.coordinatesType = res.data.coordinatesType
        this.tableHeader = res.data.properties.filter(item => {
          return item.display
        })
        this.gisHeader = this.getGisHeader(res.data.properties)
        this.next = res.data.data.next
      } finally {
        this.tableLoading = false
      }
    },
    customLabel (v) {
      if (v.tag) {
        const obj = {
          'LONGITUDE': '经度',
          'LATITUDE': '纬度',
          'HEIGHT': '高度'
        }
        const CoordName = {
          'BAIDU': '百度',
          'GAODE': '高德',
          'WSG84': 'WGS84'
        }
        return `${v.name}（设置为${obj[v.tag]}-${CoordName[this.coordinatesType]}）`
      } else {
        return v.name
      }
    },
    getGisHeader (header) {
      let lonHeader
      let latHeader
      let nameHeader
      let heightHeader
      for (let i = 0; i < header.length; i++) {
        if (header[i].tag && header[i].tag.indexOf('LONGITUDE') >= 0) {
          lonHeader = header[i].id
        }
        if (header[i].tag && header[i].tag.indexOf('LATITUDE') >= 0) {
          latHeader = header[i].id
        }
        if (header[i].nameTag && header[i].nameTag.indexOf('MARK') >= 0) {
          nameHeader = header[i].id
        }
        if (header[i].tag && header[i].tag.indexOf('HEIGHT') >= 0) {
          heightHeader = header[i].id
        }
      }
      return {
        lonHeader: lonHeader,
        latHeader: latHeader,
        nameHeader: nameHeader,
        heightHeader: heightHeader
      }
    },
    // 数据是否有gis信息
    isHaveGis (data) {
      if (data[this.gisHeader.lonHeader] && data[this.gisHeader.latHeader]) {
        const lon = parseFloat(data[this.gisHeader.lonHeader])
        const lat = parseFloat(data[this.gisHeader.latHeader])
        // 有经纬度，没名字的可通过创建标注绑定
        return !isNaN(lon) && !isNaN(lat) && data[this.gisHeader.nameHeader]
        // return !isNaN(lon) && !isNaN(lat)
      }
    },
    // 是否绑定了标注
    isBindedMarker (data) {
      for (let i = 0; i < this.markerList.length; i++) {
        if (this.markerList[i].uniqueId === data.uniqueId) {
          return true
        }
      }
      return false
    },
    show (layerId) {
      this.isShow = true
      this.reload(layerId)
    },
    reload (layerId) {
      this.clear()
      this.layerId = layerId
      this.getLayerData(layerId)
    },
    onClose () {
      if (!this.isShow) {
        return
      }
      this.clear()
      this.$emit('selectBindMarker', undefined)
      this.isShow = false
    },
    clear () {
      this.tablesData = []
      this.tableHeader = []
      this.pageNumber = 1
      this.gisHeader = {
        lonHeader: undefined,
        latHeader: undefined,
        nameHeader: undefined
      }
      this.selectedData = undefined
      this.layerType = undefined
    },
    close () {
      this.clear()
      this.isShow = false
    },
    isDisabled (item) {
      // 没经纬度，有名字的可绑定
      if (this.isHaveGis(item) && this.layerType === 'POINT') {
        return true
      }
      return false
    },
    clickChange (item, arg1, arg2) {
      if (this.isDisabled(item)) {
        return
      }
      this.selectedData = item
      this.$emit('selectBindMarker', item)
    },
    // 滚动底部加载更多
    loadMore () {
      // 判断有下一页才页码加一
      if (this.loadedData.length < this.filterData.length) {
        this.pageNumber++
        // this.getEnableTable()
        // getBindTable({
        //   pageNumber: this.pageNumber,
        //   pageSize: 20,
        //   id: this.tableId
        // }).then(res => {
        //   if (res.code === 200) {
        //     if (res.data.id !== this.tableId) {
        //       return
        //     }
        //     this.tablesData = this.tablesData.concat(res.data.data.records)
        //     this.tableHeader = res.data.properties
        //     this.gisHeader = this.getGisHeader(this.tableHeader)
        //     this.next = res.data.data.next
        //   }
        // })
      }
    },
    resize () {
      this.$nextTick(() => {
        const dom = this.$refs.main
        if (this.isRightDrawVisible && this.isLeftDrawVisible) {
          dom.style.width = '14rem'
          dom.style.left = '2.6rem'
        }
        if (!this.isRightDrawVisible && this.isLeftDrawVisible) {
          dom.style.width = '16.6rem'
          dom.style.left = '2.6rem'
        }
        if (this.isRightDrawVisible && !this.isLeftDrawVisible) {
          dom.style.width = '16.6rem'
          dom.style.left = '0'
        }
        if (!this.isRightDrawVisible && !this.isLeftDrawVisible) {
          dom.style.width = '100%'
          dom.style.left = '0'
        }
      })
    }
  },
  filters: {}
}
</script>

<style lang="scss">
.tableMarkerBind{
  width: 1660px;
  // height: 289px;
  background: #272829;
  box-shadow: 2px 0px 6px 0px rgba(12, 35, 91, 0.1);
  z-index: 100;
  position: absolute;
  bottom: 0;
  left: 260px;
  padding: 0 12px 12px 12px;
  box-sizing: border-box;
  transition: all 0.3s;
  .header{
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left{
      .name{
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #FFFFFF;
      }
      .text{
        color: rgba(153, 153, 153, 1);
      }
    }
    .right{
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 20px;
      .custom-icon{
        >svg{
          color: white !important;
        }
      }
      .line{
        width: 1px;
        height: 14px;
        background: #FFFFFF;
        opacity: 0.1;
        border-radius: 1px;
      }
    }
  }
  .tableBox{
    height: calc(100% - 36px);
    overflow: auto;
  }
}
</style>
